// @flow
import MessageBlock from './MessageBlock';
import NotAServiceBubble from './NotAServiceBubble';
import InvalidUrl from './InvalidUrl';
import urlPattern from './urlPattern';

const internalParamPrefix = 'bl.';

function internalParam(name) {
  return `${internalParamPrefix}${name}`;
}

const serviceBubbleParam = internalParam('serviceBubble');

const privateUrl = Symbol('url');

type ServiceBubbleProperties = {| +[propName: string]: string |};

export default class UrlBlock extends MessageBlock {
  // $FlowFixMe - need symbol support
  [privateUrl]: URL;
  constructor(url: string, title: ?string) {
    super();
    if (!urlPattern.test(url)) {
      throw new InvalidUrl(url);
    }
    // $FlowFixMe - need symbol support
    this[privateUrl] = new URL(url);
    if (title) {
      this.linkTitle = title;
    }
  }

  get url(): URL {
    // $FlowFixMe - need symbol support
    return this[privateUrl];
  }

  get text(): string {
    return this.url.toString();
  }

  get isServiceBubble(): boolean {
    return this.url.searchParams.has(serviceBubbleParam);
  }

  get serviceBubbleType(): string {
    return this.url.searchParams.get(serviceBubbleParam) || '';
  }

  set serviceBubbleType(serviceBubbleType: string) {
    this.url.searchParams.set(serviceBubbleParam, serviceBubbleType);
  }

  get linkTitle(): string {
    return this.url.searchParams.get(internalParam('title')) || this.cleanUrl.toString();
  }

  set linkTitle(linkTitle: string) {
    return this.url.searchParams.set(internalParam('title'), linkTitle);
  }

  get cleanUrl(): URL {
    const cleanUrl = new URL(this.url.toString());
    for (const paramName of this.url.searchParams.keys()) {
      if (paramName.startsWith(internalParamPrefix)) {
        cleanUrl.searchParams.delete(paramName);
      }
    }
    return cleanUrl;
  }

  get serviceBubbleProperties(): ServiceBubbleProperties {
    const properties: { [string]: string } = {};
    for (const [paramName, value] of this.url.searchParams.entries()) {
      if (paramName.startsWith(internalParamPrefix) && paramName !== serviceBubbleParam) {
        properties[paramName.slice(internalParamPrefix.length)] = value;
      }
    }
    // $FlowFixMe - Object.freeze should make the object exact and covariant, but it does not :(
    return Object.freeze(properties);
  }

  set serviceBubbleProperties(properties: ServiceBubbleProperties) {
    if (!this.isServiceBubble) {
      throw new NotAServiceBubble();
    }
    for (const paramName of this.url.searchParams.keys()) {
      if (
        paramName.startsWith(internalParamPrefix) &&
        paramName !== serviceBubbleParam &&
        paramName !== internalParam('title')
      ) {
        this.url.searchParams.delete(paramName);
      }
    }
    for (const [name, value] of Object.entries(properties)) {
      this.url.searchParams.set(
        internalParam(name),
        // $FlowFixMe - https://github.com/facebook/flow/issues/2221
        value,
      );
    }
  }

  toString() {
    return this.url.toString();
  }
}
